import React from "react"
import Link from "gatsby-link"
import styled, { injectGlobal } from "styled-components"
import Slider from "react-slick"
import slickStyles01 from "slick-carousel/slick/slick.css"
import slickStyles02 from "slick-carousel/slick/slick-theme.css"
import customArrow from "../svg/right-circle.svg"
import downCircleWhite from "../svg/right-circle-white.svg"
import * as vars from "../style/vars"
import { above, below } from "../style/functions"
import { RichText, Date } from "prismic-reactjs"

const TextBlock = ({ header, subheader, text, cta, invertColor = false, home = false, ctaText = 'Learn more', buttons = [] }) => {
   return (
      <Container className={invertColor ? 'invert-color' : ''} home={home}>
         <div className="grid ">
            <div className="inner">
               <MainCopy className="col col-xs-12 col-06 ">
                  {RichText.render(header)}

                  {RichText.render(subheader)}
               </MainCopy>
               {text &&
                  <Text className="col col-xs-12 col-04">
                     {RichText.render(text)}
                     {cta &&
                        <div className="button-wrapper">
                           <Link to={cta} className={`btn btn-square ${invertColor ? 'white' : ''} `}  ><span>{ctaText}</span></Link>
                        </div>
                     }
                     {buttons.length > 0 &&
                        buttons.map((btn, index) => (
                           btn.button_url.length > 0 && btn.button_url[0].text !== '' && btn.button_label.length > 0 && btn.button_label[0].text !== '' && (
                              <div className="button-wrapper" key={index}>
                                 <Link to={btn.button_url[0].text} className={`btn btn-square ${invertColor ? 'white' : ''} `}  ><span>{btn.button_label[0].text}</span></Link>
                              </div>
                           )
                        ))
                     }
                  </Text>
               }
            </div>
         </div>
      </Container>
   )
}

const Container = styled.div`
   padding: 0;
   position: relative;
   margin-bottom: ${vars.padding.inner * 2}rem;

   &:nth-child(2) {
      margin-top: ${vars.padding.inner * 2}rem;
   }

   ${props => props.home && below.mobile`
	 	margin-top:0 !important;
      .grid{
         margin: 3rem auto 7rem auto !important;
      }
   `}

   h1 {
      letter-spacing: .03rem;
      font-family: ${vars.fonts.feature};
      font-weight: normal;
      font-size:5.7rem;
      padding-bottom: ${vars.padding.inner / 2}rem;
      line-height:1;
      padding-right: 40px;
      ${below.tablet`
         padding-right: 0;
         font-size:4rem;
      `}
      ${below.mobile`
         font-size:2.6rem;
      `}
   }


   h2 {
		font-family: ${vars.fonts.main};
		font-size:2.3rem;
		font-weight: normal;
		${below.tablet`
			font-size:2.3rem;
		`}
		${below.mobile`
			font-size:2rem;
		`}
      padding-bottom: ${vars.padding.mobInner}rem;
   }

   .grid .col {
      min-height: 20rem;
      ${below.tablet`
         min-height: 0;
         padding-left: ${vars.padding.mobInner}rem;
         border-left: 1px solid ${vars.colors.body};
      `}
   }

   .grid .col:first-of-type {
      border-left: 1px solid ${vars.colors.body};
      padding-left: ${vars.padding.inner}rem;
      ${below.tablet`
         padding-left: ${vars.padding.mobInner}rem;
      `}
   }

   .border-left {
      border-left: 1px solid ${vars.colors.body};
      padding-left: ${vars.padding.inner}rem;
   }

   .mob-border-left {
      border-left-width: 0;
      padding-left: ${vars.padding.inner}rem;

      ${below.tablet`
         border-left-width: 0.2rem;
      `}
   }

   &.invert-color {
      background: ${vars.colors.body};
      color: ${vars.colors.blank};
      margin-top: 6rem;

      .grid .inner div {
         border-color: ${vars.colors.blank};
      }
   }
`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   div:last-of-type {
      max-width: 30rem;
      }
   }


   ${below.tablet`
      padding-bottom: 0;
   `};

`

const Text = styled.div`
   padding-left: ${vars.padding.inner}rem;
   border-left: 1px solid ${vars.colors.body};
   padding-bottom: ${vars.padding.mobInner}rem;
   ${above.desktop`
      width: 35.33% !important;
   `};

   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   .button-wrapper + .button-wrapper {
      margin-top: 1rem;
   }
`

export default TextBlock



// WEBPACK FOOTER //
// ./src/components/content_block.js